/**
 * @summary
 * <blockquote>Ordered list of permission verbs for RBAC</blockquote>
 **/
export const permissionOrder = [
  'create',
  'read',
  'update',
  'delete',
  'manage',
  'approve',
  'reject',
  'export',
  'import',
] as const; 